import { useState, useCallback } from 'react'
import JSZip from 'jszip'
import { FaDownload } from 'react-icons/fa'
import { createSyntheticDownload } from '@utils'
import dayjs from 'dayjs'

const KSClientPdfSplitDownloadButton = ({
    fileName,
    imagePayloads,
}) => {
    
    const [loading, setLoading] = useState(false)
    
    const onDownloadClick = useCallback(async () => {
        
        setLoading(true)
        
        const zip = new JSZip()
        const name = `${fileName}_${dayjs().format('YYYY-MM-DD')}.zip`
        
        imagePayloads.forEach((data, index) => {
            
            // Extract the base64 part and determine the file extension
            // Note: .blob here is actually the dataUri
            const base64Data = data.blob.split(',')[1]
            const mimeType = data.blob.split(';')[0].split(':')[1]
            const extension = mimeType.split('/')[1] // Get file extension (e.g., png, jpeg)
            
            // Convert base64 to binary
            const binaryString = window.atob(base64Data)
            const len = binaryString.length
            const bytes = new Uint8Array(len)
            
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i)
            }
            
            // Add file to zip
            zip.file(`${fileName}_page-${index + 1}.${extension}`, bytes, { binary: true })
            
        })
        
        const content = await zip.generateAsync({ type: 'blob' })
        
        createSyntheticDownload(content, 'application/zip', name)
        
        setLoading(false)
        
    }, [fileName, imagePayloads])
    
    return (
        
        <button
            className="btn btn-primary"
            disabled={loading || !fileName?.length || !imagePayloads?.length}
            onClick={onDownloadClick}>
            {loading ? <span className="loading loading-spinner"></span> : <FaDownload />}
            Download Images Zip
        </button>
        
    )
    
}

export default KSClientPdfSplitDownloadButton
